import React from 'react'
import { Link } from 'react-router-dom'

import { useGlobalState } from '../store'

const Logo = ({ variant = 'primary', height = 40 }) => {
  const [theme] = useGlobalState('theme')

  // @FIXME Ici, le theme doit gérer une deuxième version du logo
  return (
    <Link to={'/'} key={theme.title}>
      <img
        src={variant === 'primary' ? theme.images.logo : theme.images.logoSecondary}
        alt={theme.title}
        height={height}
      />
    </Link>
  )
}

export default Logo
